import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Row, Column, AnchorLink, AnchorLinks, Feedback, Youtube} from 'components';
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(AnchorLinks, {
      children: [_jsx(AnchorLink, {
        children: "GUI"
      }), _jsx(AnchorLink, {
        children: "CLI"
      })]
    }), "\n", _jsx(_components.h2, {
      children: "GUI"
    }), "\n", _jsx(_components.p, {
      children: "The network scanning functionality allows user to initiate a scan to discover on your network:"
    }), "\n", _jsx(_components.h3, {
      children: "Braiins"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Braiins Mini Miner"
        }), " family"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Antminers"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "S21"
        }), " family"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "S19"
        }), " family"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "S17"
        }), " family"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Whatsminers"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "M5x"
        }), " family"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "M3x"
        }), " family"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "M2x"
        }), " family"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Avalons (Beta Support)"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "A15xy"
        }), " family"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "A14xy"
        }), " family"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "A13xy"
        }), " family"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "A12xy"
        }), " family"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "A11xy"
        }), " family"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "A10xy"
        }), " family"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Icerivers"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "KAS"
        }), " family"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["The output of the scan procedure is a comprehensive list of the discovered devices, which is presented in the ", _jsx(_components.em, {
        children: "Device List"
      }), " tab."]
    }), "\n", _jsxs(_components.p, {
      children: ["Since Braiins Toolbox version 24.02 the device list in the ", _jsx(_components.strong, {
        children: "GUI"
      }), " is periodically refreshed to ensure it stays up-to-date."]
    }), "\n", _jsx(Row, {
      children: _jsx(Column, {
        colLg: 10,
        children: _jsx(Youtube, {
          id: "Evxy6fRUl98",
          title: "Network Scan"
        })
      })
    }), "\n", _jsx(_components.h2, {
      children: "CLI"
    }), "\n", _jsxs(_components.p, {
      children: ["The equivalent to the scanning functionality in CLI is a ", _jsx(_components.code, {
        children: "scan"
      }), " command. The progress of the discovery procedure is displayed in the terminal. The format for this command is:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-cmd",
        children: "$ ./braiins-toolbox scan [OPTIONS] <IP_LIST|--ip-file <FILE>>\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "where:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["the fact that ", _jsx(_components.code, {
          children: "scan"
        }), " command is used tells the Toolbox that it should scan the network defined by IP range(s)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "[OPTIONS]"
        }), " is a (possibly empty) list of options to be used during discovery scanning"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "[IP_LIST]"
        }), " is a list of IP addresses or ranges separated by space(s) with each member having the form of ", _jsx(_components.code, {
          children: "<O1>.<O2>.<O3>.<O4>"
        }), ", where each ", _jsx(_components.code, {
          children: "<Oi>"
        }), " is either an integer number between ", _jsx(_components.code, {
          children: "0"
        }), " and ", _jsx(_components.code, {
          children: "255"
        }), ", ", _jsx(_components.code, {
          children: "range"
        }), " of two integers between 0 and 255 (i.e., I1-I2 with I1 ≤ I2) or symbol ", _jsx(_components.code, {
          children: "*"
        }), " representing the whole range"]
      }), "\n", _jsxs(_components.li, {
        children: ["or instead of ", _jsx(_components.code, {
          children: "[IP_LIST]"
        }), " it is possible to apply IP addresses as an input from a text file with ", _jsx(_components.code, {
          children: "--ip-file"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Options"
    }), "\n", _jsxs(_components.p, {
      children: ["Available options are the global ones, ", _jsx(_components.a, {
        href: "/en/braiins-toolbox/running#global-options",
        children: "see here"
      }), ", or the scan specific:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--ip-file"
        }), ", which defines a path to a file containing a list of IP addresses or ranges, one per line"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--include-public-ips"
        }), " is a switch that removes the default restriction of scanning only private and link-local IP addresses"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--all-devices"
        }), " is a switch that includes unrecognized and password-protected devices in the output"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--installable-only"
        }), ",which displays devices where it is possible to install Braiins OS (i.e., supported devices with stock manufacturer firmware)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--format"
        }), ", which defines the format of the output (output is called “device list”)", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "table"
            }), ": default format, detailed device list"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "plain"
            }), ": lightweight device list in form of a list of discovered IP addresses"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "csv"
            }), ": full device list in the csv format"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--output"
        }), ", where the user defines the path to the file for saving the device list"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Help"
    }), "\n", _jsx(_components.p, {
      children: "The help option gives the user a quick overview of the command capabilities:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-cmd",
        children: "$ ./braiins-toolbox scan --help\n\nScan the provided IP addresses or ranges and print all discovered miners to stdout\n\nUsage: braiins-toolbox scan [OPTIONS] <IP_LIST|--ip-file <FILE>>\n\nArguments:\n  [IP_LIST]...  List of IP addresses or ranges\n\nOptions:\n  -i, --ip-file <FILE>                 Path to a file containing a list of IP addresses or ranges, one per line\n      --include-public-ips             This switch removes the restriction that only private and link-local IP addresses\n                                       are scanned by default\n  -I, --installable-only               Print only detected miners that the BOS can be installed to\n  -A, --all-devices                    Also include unrecognized and password protected devices\n  -f, --format <FORMAT>                Output format [default: table] [possible values: table, plain, csv]\n  -o, --output <FILE>                  Path to a file where content of standard output will be redirected\n      --pool-presets-file-path <FILE>  Path to file with pool presets\n  -p, --password <PASSWORD>            Override default password\n  -t, --timeout <DURATION>             Timeout for network operations [default: 10s]\n  -r, --scan-rate <RATE>               Number of IP addresses scanned per second. Decrease when running over a VPN or\n                                       with an unstable or slow connection. Increase when running on the same local\n                                       network where all miners are located [default: 250]\n      --logfile-path <FILE>            Path to file where debug log file\n      --max-log-size <SIZE>            Maximum size for all rolling log files combined [default: 1GB]\n  -h, --help                           Print help\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "Usage Examples"
    }), "\n", _jsx(_components.h4, {
      children: "Scan 1 IP range"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-cmd",
        children: "$ ./braiins-toolbox scan '10.10.*.2'\n\n​2023-05-01T19:09:16.812095Z  INFO braiins_toolbox::scan: scanning 256 ip addresses...\n​MAC Address        Device ID         IP Address  Firmware      Mode  Model             Control Board  Hostname      Version\n​FE:75:73:15:D3:C7  41pOfSAFanNwZUMr  10.10.5.2   Braiins OS    SD    Antminer S19      Zynq           Antminer      2023-04-21-0-aa63b2b7-23.04-plus-rc\n​3C:A3:08:6E:8B:7A  SbXSNNYaIknbbTtm  10.10.12.2  Braiins OS    SD    Antminer S19 XP   BBB            Antminer      2023-04-24-0-b2cc5307-23.03.1-plus-rc\n​DA:0F:06:4B:3D:60  -                 10.10.8.2   Bitmain Stock -     Antminer S19 XP   CVITEK         Antminer      Fri Oct 28 12:56:58 CST 2022\n​04:BB:DB:7F:82:51  3cMGBTRfSFan7Nd0  10.10.51.2  Braiins OS    SD    Antminer S9       Zynq           miner-7f8251  2022-09-27-0-26ba61b9-22.08.1-plus\n​2023-05-01T19:09:20.026977Z  INFO braiins_toolbox::scan: discovered 4 miners(0 installable)\n"
      })
    }), "\n", _jsx(_components.h4, {
      children: "Scan 2 IP ranges"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-cmd",
        children: "$ ./braiins-toolbox scan '10.10.*.2' '10.11.0-255.2'\n\n​2023-05-01T19:15:21.040511Z  INFO braiins_toolbox::scan: scanning 512 ip addresses...\n​MAC Address        Device ID         IP Address  Firmware      Mode  Model             Control Board  Hostname      Version\n​FE:75:73:15:D3:C7  41pOfSAFanNwZUMr  10.10.5.2   Braiins OS    SD    Antminer S19      Zynq           Antminer      2023-04-21-0-aa63b2b7-23.04-plus-rc\n​3C:A3:08:6E:8B:7A  SbXSNNYaIknbbTtm  10.10.12.2  Braiins OS    SD    Antminer S19 XP   BBB            Antminer      2023-04-24-0-b2cc5307-23.03.1-plus-rc\n​DA:0F:06:4B:3D:60  -                 10.10.8.2   Bitmain Stock -     Antminer S19 XP   CVITEK         Antminer      Fri Oct 28 12:56:58 CST 2022\n​04:BB:DB:7F:82:51  3cMGBTRfSFan7Nd0  10.10.51.2  Braiins OS    SD    Antminer S9       Zynq           miner-7f8251  2022-09-27-0-26ba61b9-22.08.1-plus\n"
      })
    }), "\n", _jsxs(_components.h4, {
      children: ["Scan network with an input in a text file ", _jsx(_components.code, {
        children: "input.txt"
      })]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-cmd",
        children: "$ ./braiins-toolbox scan --ip-file 'input.txt'\n\n​2023-05-01T19:15:21.040511Z  INFO braiins_toolbox::scan: scanning 307 ip addresses...\n​MAC Address        Device ID         IP Address  Firmware      Mode  Model            Control Board  Hostname      Version\n​FE:75:73:15:D3:C7  41pOfSAFanNwZUMr  10.10.5.2   Braiins OS    SD    Antminer S19     Zynq           Antminer      2023-04-21-0-aa63b2b7-23.04-plus-rc\n​3C:A3:08:6E:8B:7A  SbXSNNYaIknbbTtm  10.10.12.2  Braiins OS    SD    Antminer S19 XP  BBB            Antminer      2023-04-24-0-b2cc5307-23.03.1-plus-rc\n​DA:0F:06:4B:3D:60  -                 10.10.8.2   Bitmain Stock -     Antminer S19 XP  CVITEK         Antminer      Fri Oct 28 12:56:58 CST 2022\n​04:BB:DB:7F:82:51  3cMGBTRfSFan7Nd0  10.35.51.2  Braiins OS    SD    Antminer S9      Zynq           miner-7f8251  2022-09-27-0-26ba61b9-22.08.1-plus\n"
      })
    }), "\n", _jsx(_components.h4, {
      children: "Scan the network only for installable devices (unsupported as well as devices with Braiins OS installed on them are not displayed.)"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-cmd",
        children: "$ ./braiins-toolbox scan --installable-only '10.10.*.2'\n\n​2023-05-01T19:42:50.982704Z  INFO braiins_toolbox::scan: scanning 256 ip addresses...\n​2023-05-01T19:42:54.298224Z  INFO braiins_toolbox::scan: discovered 29 miners(0 installable)\n"
      })
    }), "\n", _jsx(_components.h4, {
      children: "Scan network with output in csv format"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-cmd",
        children: "$ ./braiins-toolbox scan --format csv '10.10.*.2'\n\n​2023-05-01T19:48:19.511154Z  INFO braiins_toolbox::scan: scanning 256 ip addresses...\n​csv​mac_address,device_id,ip_address,firmware,mode,model,control_board,hostname,version\n​csv​00:0A:35:FF:FF:FF,9v1WmwbeWThnpvdc,10.10.1.2,Braiins OS,NAND,Antminer S9,Zynq,miner-ffffff,2022-09-27-0-26ba61b9-22.08.1-plus\n​csv​4E:4E:7C:F3:8C:FD,bPgNWlauzsUhGFoR,10.10.11.2,Braiins OS,NAND,Antminer S9,Zynq,miner-f38cfd,2022-03-26-0-5091157d-22.03-plus-nightly\n​csv​00:0A:35:FF:FF:FF,2IK68av6jahk8bAd,10.10.10.2,Braiins OS,SD,Antminer S9,Zynq,miner-ffffff,2022-09-27-0-26ba61b9-22.08.1-plus\n​csv​52:0C:21:E5:F2:48,vyaebpIIfrkj4r9I,10.10.6.2,Braiins OS,NAND,Antminer S9,Zynq,miner-e5f248,2022-04-05-0-ddf6a75b-22.04-plus-nightly\n​csv​42:95:B0:C4:1C:E9,65r7DH9bWxvNrwzy,10.10.3.2,Braiins OS,SD,Antminer S9,Zynq,miner-c41ce9,2022-09-27-0-26ba61b9-22.08.1-plus\n​csv​E6:E8:72:73:AE:7E,mPJ042Z8voGxRsmv,10.10.4.2,Braiins OS,SD,Antminer S9,Zynq,miner-73ae7e,2022-09-27-0-26ba61b9-22.08.1-plus\n​csv​FE:75:73:15:D3:C7,41pOfSAFanNwZUMr,10.10.5.2,Braiins OS,SD,Antminer S19,Zynq,AntPwn,2023-04-21-0-aa63b2b7-23.04-plus-rc\n​csv​3C:A3:08:6E:8B:7A,SbXSNNYaIknbbTtm,10.10.12.2,Braiins OS,SD,Antminer S19 XP,BBB,Antminer,2023-04-24-0-b2cc5307-23.03.1-plus-rc\n​csv​BC:93:B5:03:35:24,JyuahCq6sLyGJl6b,10.10.16.2,Braiins OS,NAND,Antminer S17+,Zynq,miner-033524,2021-12-21-0-2499d1c2-21.12-plus\n​csv​DA:0F:06:4B:3D:60,,10.10.8.2,Bitmain Stock,,Antminer S19 XP,CVITEK,Antminer,Fri Oct 28 12:56:58 CST 2022\n​2023-05-01T19:48:22.682962Z  INFO braiins_toolbox::scan: discovered 10 miners(0 installable)\n"
      })
    }), "\n", _jsx(_components.h4, {
      children: "Scan network with output in plain format"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-cmd",
        children: "$ ./braiins-toolbox scan --format plain '10.10.*.2'\n\n​2023-05-01T19:51:36.222566Z  INFO braiins_toolbox::scan: scanning 256 ip addresses...\n​10.10.3.2\n​10.10.1.2\n​10.10.6.2\n​10.10.11.2\n​10.10.4.2\n​10.10.10.2\n​10.10.5.2\n​10.10.12.2\n​10.10.16.2\n​10.10.8.2\n​2023-05-01T19:51:39.391561Z  INFO braiins_toolbox::scan: discovered 10 miners(0 installable)\n"
      })
    }), "\n", _jsxs(_components.h4, {
      children: ["Scan network and persist the result in the file ", _jsx(_components.code, {
        children: "out.txt"
      })]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-cmd",
        children: "$ ./braiins-toolbox scan --format plain '10.10.*.2' --output 'out.txt'\n\n​2023-05-01T20:00:36.609877Z  INFO braiins_toolbox::scan: scanning 256 ip addresses...\n​2023-05-01T20:00:39.803100Z  INFO braiins_toolbox::scan: discovered 9 miners(0 installable)\n\n$ cat 'out.txt'\n\n​10.10.1.2\n​10.10.6.2\n​10.10.3.2\n​10.10.11.2\n​10.10.10.2\n​10.10.4.2\n​10.10.12.2\n​10.10.5.2\n​10.10.16.2\n"
      })
    }), "\n", _jsx(Feedback, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
